var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-background"},[(_vm.module === 'personal-loans')?_c('AppBackgroundPersonalLoans'):(_vm.module === 'mortgages')?_c('AppBackgroundMortgages'):(_vm.module === 'foundation')?_c('AppBackgroundFoundation'):(_vm.module === 'evergreen-loan')?_c('AppBackgroundEvergreen'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }